// src/modules/app-views/invoices/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import {
  ImportOutlined,
  DatabaseOutlined,
  PrinterOutlined,
  FileZipOutlined,
} from '@ant-design/icons';
import { openModal } from 'components/core/GenericModal';
import showMigrationDocumentModal from 'components/core/migration/MigrationDocumentModal';
import showMigrationModal from 'components/core/migration/MigrationSettingsModal';
import PrinterConfigModal from '../modals/PrinterConfigModal';
import showExportXmlModal from '../modals/ExportXmlModal';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const invoicesInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      {
        key: 'importOrder',
        label: 'migrate_document',
        icon: <ImportOutlined />,
        // Hide item if invoices migration token is not active
        hidden: ({ storedSubscription }) => {
          const tokens = storedSubscription?.migrationTokens || [];
          const invoicesToken = tokens.find(t => t.collectionName === 'invoices');
          return !invoicesToken?.isActive;
        },
        onClick: ({ refresh }) => {
          showMigrationDocumentModal({
            onSuccess: () => {
              // Refresh the list after successful import
              if (typeof refresh === 'function') {
                refresh();
              }
            },
          });
        },
      },
      'divider',
      {
        key: 'exportXml',
        label: 'export_xml',
        icon: <FileZipOutlined />,
        onClick: ({ storedCompany }) => {
          showExportXmlModal({ company: storedCompany });
        },
      },
      {
        key: 'printerConfig',
        label: 'configure_printer',
        icon: <PrinterOutlined />,
        onClick: () => {
          openModal(PrinterConfigModal, {});
        },
      },
      {
        key: 'invoicesMigrationSettings',
        label: 'migrator',
        icon: <DatabaseOutlined />,
        onClick: ({ refresh }) => {
          showMigrationModal({
            onSuccess: () => {
              // Refresh the list after migration settings change
              if (typeof refresh === 'function') {
                refresh();
              }
            },
          });
        },
      },
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default invoicesInitMenuButton;
